import SideBar from './SideBar'
import './SideBar.css'
import './background.css'

export default SideBar



// WEBPACK FOOTER //
// ./src/containers/SideBar/index.js